module.exports = __webpack_public_path__ + "img/features-pic2.bb1b9fd.svg";